"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var modal_component_1 = require("../modal.component");
var MzBaseModal = (function () {
    function MzBaseModal() {
    }
    MzBaseModal.prototype.ngAfterViewInit = function () {
        this.modalComponent.open();
    };
    return MzBaseModal;
}());
MzBaseModal.propDecorators = {
    'modalComponent': [{ type: core_1.ViewChild, args: [modal_component_1.MzModalComponent,] },],
};
exports.MzBaseModal = MzBaseModal;



//////////////////
// WEBPACK FOOTER
// ./node_modules/ng2-materialize/dist/modal/modal-base/modal-base.js
// module id = ./node_modules/ng2-materialize/dist/modal/modal-base/modal-base.js
// module chunks = vendor